import { render, staticRenderFns } from "./tgContentModal.vue?vue&type=template&id=34a8fbd2&scoped=true"
import script from "./tgContentModal.vue?vue&type=script&lang=js"
export * from "./tgContentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a8fbd2",
  null
  
)

export default component.exports